import { useState } from 'react';
import { headerNavItems } from '@/mocks/homeData';

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 h-[72px] flex items-center transition-all duration-300 bg-background-50/95 backdrop-blur-md">
      <div className="w-full px-4 md:px-6 flex items-center justify-between max-w-[1440px] mx-auto">
        <a
          href="#hero"
          onClick={(e) => handleNavClick(e, '#hero')}
          className="flex items-center gap-2 cursor-pointer shrink-0"
        >
          <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-film-line text-background-50 text-lg"></i>
          </div>
          <span className="text-xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            菲菲影院
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          <a
            href="#hero"
            onClick={(e) => handleNavClick(e, '#hero')}
            className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-full hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            首页
          </a>
          {headerNavItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-full hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-200 transition-colors cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl text-foreground-800 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden absolute top-[72px] left-0 right-0 bg-background-50 border-t border-background-200 shadow-lg">
          <nav className="flex flex-col p-4 gap-1">
            <a
              href="#hero"
              onClick={(e) => handleNavClick(e, '#hero')}
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-primary-50 transition-colors cursor-pointer"
            >
              首页
            </a>
            {headerNavItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-primary-50 transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}